import settings from '@/settings'

let getMaquinetas = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/maquineta/listar_maquinetas/?cnpj=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserirMaquineta = (maquineta, headers) => {
  return fetch(`${settings.apetrusApi}/maquineta/cadastrar_maquineta/`, {
    method: 'POST',
    body: JSON.stringify(maquineta),
    mode: 'cors',
    headers: headers
  })
}

let conectarMaquineta = (idMaquineta, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/maquineta/conectar_maquineta/`, {
    method: 'PUT',
    body: JSON.stringify({
      idMaquineta: idMaquineta,
      cnpj: cnpj
    }),
    mode: 'cors',
    headers: headers
  })
}

let desconectarMaquineta = (idMaquineta, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/maquineta/desconectar_maquineta/`, {
    method: 'PUT',
    body: JSON.stringify({
      idMaquineta: idMaquineta,
      cnpj: cnpj
    }),
    mode: 'cors',
    headers: headers
  })
}

let excluirMaquineta = (id, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/maquineta/removerMaquineta/`, {
    method: 'DELETE',
    body: JSON.stringify({
      id_maquineta: id,
      cnpj: cnpj
    }),
    mode: 'cors',
    headers: headers
  })
}

export default {
  getMaquinetas,
  inserirMaquineta,
  conectarMaquineta,
  desconectarMaquineta,
  excluirMaquineta
}
